import { Form, notification } from "antd";
import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import _ from "lodash";
import $axios from "../services/axios";

export const useHistoryLogic = ({ setLoading }) => {
    const [form] = Form.useForm();
    const [listHistory, setListHistory] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("1");
    const [hasSearched, setHasSearched] = useState(true);
    const location = useLocation();

    const rangePresets = [
        { label: "7 ngày qua", value: [dayjs().add(-7, "d"), dayjs()] },
        { label: "14 ngày qua", value: [dayjs().add(-14, "d"), dayjs()] },
        { label: "30 ngày qua", value: [dayjs().add(-30, "d"), dayjs()] },
        { label: "90 ngày qua", value: [dayjs().add(-90, "d"), dayjs()] },
    ];

    const getListHistory = useCallback(async (page, dateRange, orderCode = null) => {
        const targetPage = orderCode ? 1 : page;
        let url = `/order-hotel/findByAllUser?page=${targetPage}&pageSize=10`;
        
        if (orderCode) {
            url += `&ordercode=${orderCode}`;
        } else if (dateRange && dateRange.length === 2) {
            const startTime = dayjs(dateRange[0]).format("DD/MM/YYYY");
            const endTime = dayjs(dateRange[1]).format("DD/MM/YYYY");
            url += `&startDate=${startTime}&endDate=${endTime}`;
        } else {
            return;
        }

        setLoading(true);
        try {
            const res = await $axios.$get(url);
            setListHistory(res.data?.data?.data || []);
            setTotal(res.data?.data?.totalRecordCount || res.data?.data?.data?.totalRecordCount || 0);
        } catch (error) {
            notification.error({
                message: "Lỗi",
                description: "Không thể lấy thông tin lịch sử đặt phòng.",
            });
        } finally {
            setLoading(false);
        }
    }, [setLoading]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const orderCode = queryParams.get("orderCode");
        const tab = queryParams.get("tab");

        if (tab) {
            setActiveTab(tab);
        }

        if (orderCode) {
            getListHistory(currentPage, null, orderCode);
        } else {
            getListHistory(currentPage, _.get(rangePresets, "[0].value", []));
        }
    }, [location.search, currentPage, getListHistory]);

    const onFinish = async (values) => {
        try {
            setHasSearched(true);
            setCurrentPage(1);
            if (activeTab === "2") {
                if (!values.orderCode) return;
                await getListHistory(1, null, values.orderCode);
            } else {
                if (!values.dateRange || values.dateRange.length < 2) return;
                await getListHistory(1, values.dateRange);
            }
        } catch (error) {
            notification.error({
                message: "Lỗi",
                description: "Không thể lấy thông tin lịch sử.",
            });
        }
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
        setListHistory([]);
        setTotal(0);
        setHasSearched(false);
    };

    return {
        form,
        listHistory,
        total,
        currentPage,
        setCurrentPage,
        rangePresets,
        getListHistory,
        onFinish,
        activeTab,
        handleTabChange,
        hasSearched
    };
};
